import { withAuth } from 'HOCs';
import { Header } from 'components/molecules';
import DashboardTemplate from 'components/templates/PublicServicesTemplate/DashboardTemplate';


const breadcrumbs = [{ label: 'Servicios públicos' }];

const DashboardPage = () => {
  return (
    <>
      <Header
        title="Dashboard"
        subtitle="Resumen de facturas procesadas"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <DashboardTemplate />
    </>
  );
}

export default withAuth(DashboardPage);